export const getPageKeyForSaveService = (pageType, id, dashboardBaseKey?) => {
  const isSavedDashboard = pageType === 'saved';
  const isSharedDashboard = pageType === 'sharing';

  if (isSavedDashboard && id) {
    return id;
  }
  else if (isSharedDashboard && id) {
    return `sharing-${id}`;
  }
  // sd-todo: check what to do on dashboardBaseKey=null
  return dashboardBaseKey;
}